module.exports = __webpack_public_path__ + "static/img/login.63c9fc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/login.png
// module id = CBn3
// module chunks = 0